import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class WeightScale extends React.Component{

  render(){
    let avg_weight=((Number(this.props.weight_min) + Number(this.props.weight_max)) / 2);
    let percent=0;
    if(avg_weight>320 && avg_weight<350){
      percent= (avg_weight - 320) / (350 - 320) *20;
    }
    else if(avg_weight>=350 && avg_weight<375){
      percent= ((avg_weight - 350) / (375 - 350) *20)  +20;
    }
    else if(avg_weight>=375 && avg_weight<410){
      percent= ((avg_weight - 375) / (410 - 375) *20)  +40;
    }
    else if(avg_weight>=410 && avg_weight<440){
      percent= ((avg_weight - 410) / (440 - 410) *20)  +60;
    }
    else if(avg_weight>=440 && avg_weight<500){
      percent= ((avg_weight - 440) / (500 - 440) *20)  +80;
    }
    else if (avg_weight>=500) {
      percent=100;
    }

    return(
      <div aria-label={"The " + this.props.shoe_name + " in size 9 weighs around " + avg_weight.toFixed(0) + "g"} style={{flex:1,}}>
  			<div style={{display: 'flex'}}>
  				<div style={{flex: '1 1 0%', textAlign: 'left', fontSize: 12}}>light</div>
  				<div style={{flex: '1 1 0%', textAlign: 'right', fontSize: 12}}>heavy</div>
  			</div>
  			<div style={{display: 'flex', position: 'relative'}}>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
  				<div style={{flex: '1 1 0%', height: 15, borderStyle: 'solid', backgroundColor: '#e5e5e5', borderColor: '#999999', borderWidth: 1}}></div>
          <OverlayTrigger placement="bottom" overlay={
            <Tooltip  style={{fontSize:15}} id="tooltip">
              The {this.props.shoe_name} in size 9 weighs around {avg_weight.toFixed(0)}g
            </Tooltip>
            }>
            <div className="size_scale_indicator" style={{position: 'absolute', height: 15,border:"1px solid border: 1px solid var(--primary-color-800)",backgroundColor: 'var(--primary-color-600)', width: '20%', opacity: 0.9, textAlign: 'center', color: 'white', left:percent*0.8 + "%"}}> </div>
          </OverlayTrigger>
    		 </div>
  		</div>
    );
  }
}
